import { styled, Typography, AppBar as MuiAppBar, Toolbar as MuiToolbar, Box } from '@mui/material';
import { topBarBkColor, themeBoxSecondaryShadow, containerFluid, primaryColor } from 'assets/jss/styles';

export const AppBar = styled(MuiAppBar)(({ theme }) => ({
  marginBottom: '0',
  width: '100%',
  zIndex: '1029',
  color: theme.palette.primary.main,
  border: '0',
  borderRadius: '3px',
  transition: 'all 150ms ease 0s',
  minHeight: '50px',
  display: 'block',
  '@media (max-width: 80px)': {
    position: 'relative',
    backgroundColor: theme.palette.sideMenu.bgColor + '!important',
    padding: 0
  },
  backgroundColor: topBarBkColor(theme),
  ...themeBoxSecondaryShadow(theme)
}));

export const Toolbar = styled(MuiToolbar)(() => ({
  ...containerFluid,
  minHeight: '50px',
  '@media (max-width: 80px)': {
    display: 'flex',
    flexDirection: 'column'
  }
}));

export const MinimizeSidebar = styled('div')(() => ({
  float: 'left',
  paddingBlock: '10px',
  paddingRight: '15px',
  display: 'block',
  color: '#555555'
}));

export const StyledTitle = styled(Typography)(({ theme }) => ({
  borderRadius: '3px',
  textTransform: 'none',
  fontWeight: 'bold',
  flexGrow: 1,
  color: primaryColor(theme),
  '&:hover,&:focus': {
    background: 'transparent'
  }
}));

export const StyledMobileTitle = styled(Typography)(({ theme }) => ({
  borderRadius: '3px',
  textTransform: 'none',
  fontWeight: 'bold',
  flexGrow: 1,
  color: primaryColor(theme),
  '&:hover,&:focus': {
    background: 'transparent'
  }
}));

export const HeaderRef = styled('div')(() => ({
  flex: 1,
  '@media (max-width: 80px)': {
    width: 'calc(100% - 30px)',
    marginRight: '30px'
  }
}));

export const HeaderResponsive = styled('div')(() => ({
  paddingBlock: '10px',
  paddingLeft: '10px',
  '@media (max-width: 80px)': {
    position: 'absolute',
    padding: '5px 15px',
    right: 0,
    top: 0
  }
}));

export const HeaderContentWrapper = styled(Box)(({ theme }) => ({
  flexGrow: 1,
  paddingInline: theme.spacing(1),
  minWidth: 0
}));
